import React, { Component } from 'react'
import { translate } from '../Services/translation'
import VehicleFinder from '../Components/VehicleFinder'
import VehicleData from '../Components/VehicleData'
import withVehicleFinder from '../HOC/withVehicleFinder'
import { get } from '../Services/http'
import DimensionSearch from '../Components/DimensionSearch'
import LoadingOverlay from '../Components/LoadingOverlay'
import constants from '../constants'

class VehicleFinderContainer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dimensionFilters: [],
            loading: false,
            showInfo: false,
        }
        this.elementRef = React.createRef()
        this.getTireQueryFilters = this.getTireQueryFilters.bind(this)
        this.getCompleteWHeelsQueryFilters =
            this.getCompleteWHeelsQueryFilters.bind(this)
        this.handleRemoveVehicle = this.handleRemoveVehicle.bind(this)
    }

    componentDidMount() {
        get('/api/vehicleFinder/GetDimensionFilters')
            .then((res) => res.json())
            .then((data) => {
                if (this.elementRef.current != null)
                    this.setState({ dimensionFilters: data })
            })
            .catch((e) => console.log(e))
    }

    componentDidUpdate(prevProps) {
        const vehicleData = this.props.vehicleFinder?.vehicleData
        const prevVehicleData = prevProps.vehicleFinder?.vehicleData

        if (vehicleData && vehicleData !== prevVehicleData) {
            window.scrollTo({
                top: this.elementRef?.current?.offsetTop - 130,
                behavior: 'smooth',
            })
        }
    }

    componentWillUnmount() {}

    getOriginalDiameter() {
        const { vehicleData } = this.props.vehicleFinder
        if (!vehicleData?.rims?.length) return null
        const originalRim =
            vehicleData.rims.find((r) => r.isOriginal) ?? vehicleData.rims[0]
        return originalRim?.diameter ?? null
    }

    getTireQueryFilters() {
        const { vehicleData } = this.props.vehicleFinder
        const diameter = this.getOriginalDiameter()
        if (!diameter || !vehicleData) return ''

        const selectedTireSize = vehicleData.tires.find(
            (tire) => tire.diameter == diameter
        )
        if (!selectedTireSize) return ''
        return `?${constants.filterTags.height}=${selectedTireSize.profile}&${constants.filterTags.diameter}=${selectedTireSize.diameter}&${constants.filterTags.widthInMm}=${selectedTireSize.width}`
    }

    getRimQueryFilters() {
        const { vehicleData } = this.props.vehicleFinder
        const diameter = this.getOriginalDiameter()
        if (!diameter || !vehicleData) return ''

        return `?${constants.filterTags.diameter}=${diameter}`
    }

    getCompleteWHeelsQueryFilters() {
        const { vehicleData } = this.props.vehicleFinder
        const diameter = this.getOriginalDiameter()
        if (!diameter || !vehicleData) return ''
        if (Object.keys(vehicleData.selectedProducts).length == 0)
            return `?${constants.filterTags.diameter}=${diameter}`
        return ''
    }

    handleRemoveVehicle() {
        this.props.removeVehicle()
    }

    render() {
        const { vehicleData, errors } = this.props.vehicleFinder
        const tireUrl =
            this.props.tireCategoryPageUrl + this.getTireQueryFilters()
        const rimUrl = this.props.rimCategoryPageUrl + this.getRimQueryFilters()
        const completeWheelsUrl =
            this.props.completeWheelsPageUrl +
            this.getCompleteWHeelsQueryFilters()
        let filters = {}
        this.state.dimensionFilters?.forEach((filter) => {
            filters[filter.id] = filter
        })

        return (
            <>
                <div
                    ref={this.elementRef}
                    className={
                        'columns small-12 medium-6 large-5 vehicle-finder' +
                        (!vehicleData ? ' align-items-top' : '')
                    }
                >
                    {!vehicleData && !this.props.moveOnWithoutVehicle && (
                        <>
                            <div className="small-12 vehicle-finder__title-container">
                                <h1 className="vehicle-finder__title">
                                    {translate('ecom.startpage.title')}
                                </h1>
                            </div>
                            <VehicleFinder
                                vehicleData={vehicleData}
                                errors={errors}
                                handleRegNoInputChange={
                                    this.props.handleRegNoInputChange
                                }
                                getVehicleDataByRegNo={
                                    this.props.getVehicleDataByRegNo
                                }
                                handleRegNoInputClick={
                                    this.props.handleRegNoInputClick
                                }
                                regNo={this.props.regNo}
                                getVehicleDataByVehicleSelector={
                                    this.props.getVehicleDataByVehicleSelector
                                }
                                loading={this.props.loading}
                            />
                            {!this.props.moveOnWithoutVehicle && (
                                <div className="vehicle-finder__move-on-link">
                                  <p>{translate('ecom.startpage.moveonwithoutvehiclelabel')}</p>
                                    <a
                                        onClick={
                                            this.props
                                                .handleMoveonWithoutVehicleClick
                                        }
                                    >
                                        {translate(
                                            'ecom.startpage.moveonwithoutvehicle'
                                        )}
                                    </a>
                                </div>
                            )}
                        </>
                    )}

                    {vehicleData && (
                        <div style={{ color: 'white', width: '100%' }}>
                            <VehicleData
                                vehicleData={vehicleData}
                                removeVehicle={this.handleRemoveVehicle}
                            />
                            <h4
                                style={{
                                    fontSize: '36px',
                                    marginTop: '20px',
                                    marginBottom: '30px',
                                }}
                                className="vehicle-finder__title"
                            >
                                {translate(
                                    'ecom.startpage.vehiclesearchtitle'
                                )}
                            </h4>
                            <div className="selection-container-test">
                                <MoveOnLinks
                                    tireUrl={tireUrl}
                                    rimUrl={rimUrl}
                                    completeWheelsUrl={completeWheelsUrl}
                                />
                            </div>
                        </div>
                    )}

                    {this.props.moveOnWithoutVehicle &&
                        (this.state.dimensionFilters.length > 0 ? (
                            <div style={{ width: '100%' }}>
                                <a
                                    onClick={this.props.handleGoBack}
                                    style={{ color: 'white' }}
                                >
                                    {translate('ecom.startpage.goback')}
                                </a>
                                <DimensionSearch
                                    infoPopupImage={
                                        this.props.tireDimensionImage
                                    }
                                    infoPopupContent={
                                        this.props.tireDimensionContent
                                    }
                                    onMoveOn={() =>
                                        this.setState({ loading: true })
                                    }
                                    filters={filters}
                                    tireUrl={this.props.tireCategoryPageUrl}
                                />
                            </div>
                        ) : (
                            <div className="dimension-search-loading">
                                <div className="lds-ring">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                        ))}
                </div>
                <div
                    id="vehicleFinderImage"
                    className="small-12 medium-6 large-7 vehicle-finder__image-container hide-for-small-only"
                    style={{
                        backgroundImage:
                            'url(' + this.props.bannerImageUrl + ')',
                    }}
                >
                    <span
                        className="vehicle-finder__image-text"
                        style={{ color: this.props.textColor }}
                        dangerouslySetInnerHTML={{ __html: this.props.text }}
                    ></span>
                </div>
                <LoadingOverlay loading={this.state.loading} />
            </>
        )
    }
}

const MOVE_ON_LINK_CATEGORY = {
    TIRE: 'tire',
    RIM: 'rim',
    COMPLETE_WHEELS: 'completewheels',
}

function MoveOnLink({ href, category }) {
    return (
        <a href={href}>
            <button>{translate(`ecom.startpage.${category}link.title`)}</button>
        </a>
    )
}

function MoveOnLinks({ tireUrl, rimUrl, completeWheelsUrl }) {
    return (
        <>
            <MoveOnLink
                href={completeWheelsUrl}
                category={MOVE_ON_LINK_CATEGORY.COMPLETE_WHEELS}
            />
            <MoveOnLink
                href={tireUrl}
                category={MOVE_ON_LINK_CATEGORY.TIRE}
            />
            <MoveOnLink
                href={rimUrl}
                category={MOVE_ON_LINK_CATEGORY.RIM}
            />
        </>
    )
}

export default withVehicleFinder(VehicleFinderContainer)
